import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'manual-trigger',
  name: 'Manual Trigger',
  category: 'triggers',
  description: 'Manually trigger workflow execution for testing and development',
  icon: 'Play',
  color: 'green',
  version: '1.0.0',
  
  group: ['trigger'],
  
  defaults: {
    name: 'When clicking "Test workflow"',
    color: '#22c55e'
  },
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],
  
  maxNodes: 1, // Only one manual trigger allowed per workflow
  
  tags: ['manual', 'trigger', 'test', 'debug'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.manualworkflowtrigger/'
  }
};

export default definition;
